@for (notification of globalNotifications ; track notification.id) {
    <div class="flex flex-row p-2 text-xs sm:text-sm text-ponder justify-center" [ngClass]="{ 'bg-orange-400' : $even, 'bg-orange-300' : $odd }">
        <div class="grow text-center">
            {{ notification.message }} 
            @if (notification.linkedPost) {
                <a (click)="onCloseNotification(notification)" href="/news?id={{ notification.linkedPost }}" class="text-ponder-link hover:text-ponder-linkhover hover:cursor-pointer">(read more)</a>
            }
        </div>
        <button class="pl-4 pr-4" (click)="onCloseNotification(notification)">
            <svg-icon [svgIcon]="svgIcon" [small]="true" class="stroke-ponder hover:stroke-white"></svg-icon>
        </button>
    </div>
}